import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useNewsDetailDispatch } from "./news-detail-context";

export const useNewsDetailController = () => {
    const NewsDetailDispatch = useNewsDetailDispatch();

    async function loadDetail(id: number) {
        try {
            NewsDetailDispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });

            const result = await PortalAppService.getNewsDetail(id);

            NewsDetailDispatch({
                type: ACTION_TYPES.setDetail,
                payload: result,
            });
        } catch (error) {
            console.error('Erro ao carregar detalhes da notícia:', error);
            NewsDetailDispatch({
                type: ACTION_TYPES.setError,
                payload: 'Erro ao carregar os detalhes da notícia',
            });
        }
    }

    return {
        loadDetail
    };
}
